import { IDynamicLinkedServiceTypeMetadata, ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { ConnectionAuthKind } from 'shell-models-lib';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import {
    commonFileTypeStoreGetMetadataActivityReadSettings,
    commonFileTypeStoreDeleteActivityReadSettings,
    getCommonFileTypeStoreReadSettingControls,
    getCommonBinaryStoreReadSettingControls,
    getAccessKeySecretUrl,
    getCommonDeltaStoreReadSettingControls,
    cdcDestination
} from '../consts/metadata-consts';
import { binaryMetadata } from '../dataset/binary-metadata';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { GlobalVariables } from 'app/services/globals';
import { deltaMetadata } from '../dataset/delta-metadata';

export const oracleCloudStorageMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.oracleCloudStorage.linkedServiceType,
        displayName: stringResources.OracleCloudStorage,
        supportedInTrident: true,
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        supportedAuthKindsInTrident: [ConnectionAuthKind.Basic],
        supportOPDG: GlobalVariables.enableOPDG,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'OracleCloudStorage' as ResourceKind
        },
        supportCopyJobSource: true,
        ...(GlobalVariables.copyJobGenericCdc ? {
            cdc: {
                supportCDC: true,
                supportedCDCDestinations: cdcDestination,
                supportGenericCdc: true
            }
        } : {}),
        linkedServiceKind: 'file',
        icon: {
            className: 'svg-i-100x100-Oracle'
        },
        isFirstClass: true,
        supportGetMetadataActivity: true,
        supportIncrementalBinaryCopy: true,
        supportDatasetV2: true,
        notSupportCopySink: true,
        locationPattern: {
            bucketName: '([^/]*)/?[^]*',
            folderPath: '[^/]*/([^]*)/[^/]*',
            fileName: '[^]*/([^/]*)'
        },
        containerLabel: stringResources.InputBucketPlaceHolder,
        containerLabelPlural: stringResources.InputBucketsPlaceHolder,
        locationPropertiesRequireParameters: ['bucketName', 'folderPath', 'fileName'],
        mergeReadSettingsInTrident: true,
        getMetadataActivityReadProperties: commonFileTypeStoreGetMetadataActivityReadSettings,
        supportFirstClassParameterExperience: true,
        deleteActivityReadProperties: commonFileTypeStoreDeleteActivityReadSettings,
        supportTestConnectionToFilePath: true,
        storeReadSettingControls: getCommonFileTypeStoreReadSettingControls(true),
        datasetTypeToStoreReadSettingControls: {
            [binaryMetadata.type]: getCommonBinaryStoreReadSettingControls(true),
            [deltaMetadata.type]: getCommonDeltaStoreReadSettingControls()
        },
        category: ['File'],
        controls: getAccessKeySecretUrl(stringResources.OracleCloudStorage, true),
        copySinkTypes: [],
        copySourceTypes: []
    };
    return metadata;
}

